import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomHeaderComponent } from './custom-header/custom-header.component';
import { CommonHeaderComponent } from './common-header/common-header.component';
import { BackComponent } from './common-header/back/back.component';

import { MenuIndexComponent } from '../core/header-menu/menu-index/menu-index.component';
import { HeaderMenuComponent } from '../core/header-menu/header-menu.component';
import { LoaderComponent } from './header-menu/loader/loader.component';
import { MenuLocationComponent } from './header-menu/menu-location/menu-location.component';
import { MaterialModule } from '../modules/material.module';
import { RouterModule } from '@angular/router';

import { WarningButtonComponent } from './buttons/warning-button/warning-button.component';
import { ErrorButtonComponent } from './buttons/error-button/error-button.component';
import { DefaultButtonComponent } from './buttons/default-button/default-button.component';
import { SuccessButtonComponent } from './buttons/success-button/success-button.component';
import { PrimaryButtonComponent } from './buttons/primary-button/primary-button.component';
import { SmallSuccessButtonComponent } from './buttons/success-button-small/small-success-button.component';

import { OrderStatusComponent } from './order-status/order-status.component';
import { OrderStatusIconComponent } from './order-status-icon/order-status-icon.component';

import { PanelComponent } from './panel/panel.component';
import { InputCharacteristicsPanelComponent } from './panel/input-characteristics-panel/input-characteristics-panel.component';
import { OutputCharacteristicsPanelComponent } from './panel/output-characteristics-panel/output-characteristics-panel.component';
import { CharacteristicsPanelComponent } from './panel/characteristics-panel/characteristics-panel.component';
import { CharacteristicIconsComponent } from './panel/characteristics-icons/characteristics-icons.component';
import { FieldComponent } from './panel/field/field.component';
import { MultiFieldComponent } from './panel/multi-field/multi-field.component';

import { CardStatusComponent } from './tree-card/card-status/card-status.component';
import { CardDependencyComponent } from './tree-card/card-dependency/card-dependency.component';
import { CardOperationComponent } from './tree-card/card-operation/card-operation.component';
import { CardNameComponent } from './tree-card/card-name/card-name.component';
import { CardDescriptionComponent } from './tree-card/card-description/card-description.component';
import { CommonPopupComponent } from './common-popup/common-popup.component';
import { MenuUserComponent } from './header-menu/menu-user/menu-user.component';
import { CardStatusProcessComponent } from './tree-card/card-status-process/card-status-process.component';
import { TaskTypeComponent } from './task-type/task-type.component';
import { ChipComponent } from './chip/chip.component';
import { BillingInfoComponent } from './billing-info/billing-info.component';
import { OffersListComponent } from './offers-list/offers-list.component';
import { OfferCharacteristicComponent } from './offers-list/offer-characteristic/offer-characteristic.component';
import { ChangeDateComponent } from './change-date/change-date.component';
import { NotificationComponent } from './notification/notification.component';
import { JsonComponent } from './json/json.component';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { DiagramComponent } from './diagram/diagram.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog.component';
import { TraceabilityListComponent } from './traceability/traceability-list/traceability-list.component';
import { TraceabilityDetailComponent } from './traceability/traceability-detail/traceability-detail.component';
import { FirstCasePipe } from '../pipes/first-case.pipe';
import { SharedModule } from '../shared/shared.module';
import { PipesModule } from '../pipes/pipes.module';

@NgModule({
  declarations: [HeaderMenuComponent, MenuIndexComponent, LoaderComponent, MenuLocationComponent,
    CustomHeaderComponent, CommonHeaderComponent, BackComponent,
    WarningButtonComponent, ErrorButtonComponent, DefaultButtonComponent, SuccessButtonComponent, PrimaryButtonComponent, SmallSuccessButtonComponent,
    OrderStatusComponent, OrderStatusIconComponent,
    PanelComponent, InputCharacteristicsPanelComponent, OutputCharacteristicsPanelComponent, CharacteristicsPanelComponent, CharacteristicIconsComponent, FieldComponent, MultiFieldComponent,
    CardDescriptionComponent, CardStatusProcessComponent, CardStatusComponent, CardDependencyComponent, CardOperationComponent, CardNameComponent, CommonPopupComponent, MenuUserComponent,
    TaskTypeComponent, ChipComponent, BillingInfoComponent, OffersListComponent, OfferCharacteristicComponent, ChangeDateComponent, NotificationComponent, JsonComponent, DiagramComponent,
    ConfirmationDialogComponent, TraceabilityListComponent, TraceabilityDetailComponent],
  imports: [
    MaterialModule,
    CommonModule,
    RouterModule,
    PipesModule,
    SharedModule,
    TranslateModule.forChild(),
  ],
  entryComponents: [
    DiagramComponent,
    ConfirmationDialogComponent,
    TraceabilityDetailComponent
  ],
  providers: [
		TranslatePipe,
    FirstCasePipe

  ],
  exports: [HeaderMenuComponent, CustomHeaderComponent, CommonHeaderComponent, CommonPopupComponent, BackComponent,
    WarningButtonComponent, ErrorButtonComponent, DefaultButtonComponent, SuccessButtonComponent, PrimaryButtonComponent, SmallSuccessButtonComponent,
    OrderStatusComponent,
    PanelComponent, InputCharacteristicsPanelComponent, OutputCharacteristicsPanelComponent, CharacteristicsPanelComponent, CharacteristicIconsComponent, FieldComponent, MultiFieldComponent,
    CardDescriptionComponent, CardStatusProcessComponent, CardStatusComponent, CardDependencyComponent, CardOperationComponent, CardNameComponent, CommonPopupComponent,
    TaskTypeComponent, ChipComponent, BillingInfoComponent, OffersListComponent, OfferCharacteristicComponent, ChangeDateComponent, TraceabilityListComponent, TraceabilityDetailComponent
  ]
})
export class CoreModule { }
